import axios from "axios";

const getAuthToken = () => localStorage.getItem(process.env.VUE_APP_TOKEN_NAME) || null;

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_IP,
  headers: {
    "Content-Type": "application/json",
    [process.env.VUE_APP_TOKEN_NAME]: getAuthToken(),
    app: "autologin",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    if (token) {
      config.headers[process.env.VUE_APP_TOKEN_NAME] = `${token}`;
    }

    if (config.data instanceof FormData) {
      if (config.headers?.delete) {
        config.headers.delete("Content-Type");
      } else {
        delete config.headers["Content-Type"];
      }
    }

    return config;
  },
  (error) => {
    console.error("Request error:", error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (data.hasOwnProperty("validSession") && !data.validSession) {
      window.location.href = "/sesionwrong";
    }
    return response;
  },
  (error) => {
    console.error("Response error:", error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
